import { bySiiStatus } from './bySiiStatus';
import { type Result, type SelectResult } from './types';

const selectByCode =
  (code: string) =>
  ({ data, isFetching, isLoading, isError }: Result): SelectResult => {
    if (data === undefined)
      return {
        isFetching,
        isLoading,
        isError,
        data: null,
      };

    const siiStatusRecord = data.find(bySiiStatus(code));

    return {
      isFetching,
      isError,
      isLoading,
      data: siiStatusRecord ?? null,
    };
  };

export { selectByCode };
